// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Chart } from "chart.js/auto";
import { format } from "date-fns";
import { flatMap, map, max, pick } from "lodash-es";
import { getNearestEarlyTimeElement } from "duck";
import { Vital } from "requests";
import { MAX_X_AXIS } from "./constants";

export const getTimeSortedVitals = (vitals: any) => {
  return [...vitals].sort((a, b) => {
    const timeA = new Date(a.timeMonitoring);
    const timeB = new Date(b.timeMonitoring);
    if (timeA < timeB) {
      return -1;
    }
    if (timeA > timeB) {
      return 1;
    }
    return 0;
  });
};

export const getMaxVitalsNumber = (data?: Vital[]) => {
  const values = flatMap(data, obj => {
    const pickedObj = pick(obj, [
      "diastolicBloodPressure",
      "endTidal",
      "heartRate",
      "meanBloodPressure",
      "pulseOximetry",
      "respiratoryRate",
      "systolicBloodPressure"
    ]);
    return map(pickedObj, value => value);
  });

  return max(values);
};

/* eslint-disable */
export const moveChartForward = (chart?: Chart | null) => {
  const countOfLabels = chart?.data?.labels?.length || 0;
  if (chart) {
    chart.options.scales.x.min += 3;
    chart.options.scales.x.max += 3;
    if (chart.options.scales.x.max >= countOfLabels) {
      chart.options.scales.x.min = countOfLabels - MAX_X_AXIS - 1;
      chart.options.scales.x.max = countOfLabels - 1;
    }
    chart.update();
  }
};

export const moveChartBack = (chart?: Chart | null) => {
  if (chart) {
    chart.options.scales.x.min -= 3;
    chart.options.scales.x.max -= 3;
    if (chart.options.scales.x.min <= 0) {
      chart.options.scales.x.min = 0;
      chart.options.scales.x.max = MAX_X_AXIS;
    }
    chart.update();
  }
};

export const moveChartToCurrentTime = (chart?: Chart | null, timeIntervals) => {
  const nearestElement = getNearestEarlyTimeElement(timeIntervals);
  const indexOfNearestElement = timeIntervals.findIndex(
    el => el === nearestElement
  );
  if (chart) {
    chart.options.scales.x.min = indexOfNearestElement - 2;
    chart.options.scales.x.max = MAX_X_AXIS + indexOfNearestElement;

    chart.update();
  }
};

export function getVitalDatasets(sortedVitalsByTime) {
  return sortedVitalsByTime.reduce((result, vital) => {
    const vitalKeys = [
      "heartRate",
      "respiratoryRate",
      "pulseOximetry",
      "endTidal",
      "systolicBloodPressure",
      "meanBloodPressure",
      "diastolicBloodPressure"
    ];
    vitalKeys.forEach(key => {
      if (vital[key] !== null) {
        if (!result[`${key}DataSet`]) result[`${key}DataSet`] = [];
        result[`${key}DataSet`].push({
          y: vital[key],
          x: format(new Date(vital.timeMonitoring), "h:mm a")
        });
      }
    });
    return result;
  }, {});
}
/* eslint-enable */
